import type { JSX } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { AlignItems, Display, Spacing } from 'src/styles';

interface SampleDocumentDownloadLinkProps {
  text: string;
  link: string;
  className?: string;
  testId?: string;
}

export const SampleDocumentDownloadLink = ({
  text,
  link,
  className,
  testId,
}: SampleDocumentDownloadLinkProps): JSX.Element => {
  return (
    <a
      href={link}
      target='_blank'
      rel='noreferrer'
      className={cx(Display.flex, AlignItems.center, className)}
      data-testid={testId + '-download-document'}>
      <DownloadOutlined className={Spacing.mr4} /> <span> {text}</span>
    </a>
  );
};
